import { createContext, useContext } from 'react';
import PlausibleProvider from 'next-plausible';
import usePlausibleAnalytics from './usePlausibleAnalytics.hook';

const PlausibleContext = createContext();

const domain = {
  development: 'localhost',
  staging: 'staging.rockalingua.com',
  production: 'rockalingua.com',
}[process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT];

export default function PlausibleAnalytics({ children }) {
  const { state, actions } = usePlausibleAnalytics();

  return (
    <PlausibleProvider
      domain={domain}
      customDomain="https://plausible.rockalingua.com"
      selfHosted
      trackLocalhost
      enabled
      manualPageviews
    >
      <PlausibleContext.Provider value={{ state, actions }}>
        {children}
      </PlausibleContext.Provider>
    </PlausibleProvider>
  );
}

export const usePlausibleContext = () => useContext(PlausibleContext);
